module.exports = __webpack_public_path__ + "img/wallet.f756e1fa.png";